import React from 'react';
import Main from '../components/Main/Main';
import Footer from '../components/Footer/Footer';
import NavBar from '../components/Navbar/NavBar.js';

function Home() {
  return (
        <div>
            <NavBar/>
            <Main/>
            <Footer/>
        </div>
  )
}

export default Home
